import { GetMessengerHashesOutput } from '@allocab/allocab-driver-shared-types';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '../../../services/datastore/queryKeys';
import { QueryOptions } from '../../../services/datastore/types';
import { driverApi } from '../../../services/network/Api';

const fetchIntercom = () =>
  driverApi.get<void, GetMessengerHashesOutput | null>('/v1/support/intercom/intercom/hashes');

export const useFetchIntercom = (
  options: QueryOptions<typeof queryKeys.user.fetchIntercom, GetMessengerHashesOutput | null> = {},
) => useQuery(queryKeys.user.fetchIntercom(), fetchIntercom, options);
